import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

export const formatNumber = (num) => {
  if (num >= 1000000) {
    return (num / 1000000).toFixed(1) + 'M'
  }
  if (num >= 1000) {
    return (num / 1000).toFixed(1) + 'K'
  }
  return num.toString()
}

export const getStatusColor = (status) => {
  switch (status?.toLowerCase()) {
    case 'active':
      return 'from-emerald-400 to-emerald-600'
    case 'inactive':
      return 'from-red-400 to-red-600'
    case 'maintenance':
      return 'from-amber-400 to-amber-600'
    default:
      return 'from-slate-400 to-slate-600'
  }
}

export const getRiskColor = (risk) => {
  if (risk < 6) return 'from-emerald-400 to-emerald-600'
  if (risk < 15) return 'from-amber-400 to-amber-600'
  return 'from-red-400 to-red-600'
}